import { Component, ElementRef, OnDestroy, ViewChild , Optional} from '@angular/core';
import { ICellEditorAngularComp } from 'ag-grid-angular';
import { FormBuilder, FormControl } from '@angular/forms';
import { IAfterGuiAttachedParams, ICellEditorParams } from 'ag-grid-community';
import { FxAgGridValidationEditorComponent } from './fx-ag-grid-validation-editor';
import { FxAgGridEventHandlerService } from './fx-ag-grid-event-handler.service';
import {Subscription} from 'rxjs';
import {FxModalService} from '../components/fx-modal/fx-modal.service';

@Component({
  selector: 'fx-country-button-editor',
  template: `
    <div dw-tooltip dwPlacement="topLeft" dwOverlayClassName="ag-invalid-cell-overlay"
         [dwTitle]="errorContent" [dwVisible]="errorVisible"
         *ngIf="errorVisible"></div>
    <ng-template #errorContent>
      <div *ngFor="let msg of validationMessages">{{ message }} {{ msg.key | translate:msg.params }}</div>
    </ng-template>
    <form [formGroup]="validateForm">
      <dw-form-control>
        <dw-input-group dwSearch [dwSuffix]="suffix_2">
          <input [formControl]="formControl" dw-input placeholder="" [attr.disabled]="dwDisabled?'':null" #cellInput>
        </dw-input-group>
      </dw-form-control>
    </form>
    <ng-template #suffix_2>
      <button dw-button dwType="primary" dwSearch (click)="openModal()">
        <i class="anticon anticon-search"></i>
      </button>
    </ng-template>
  `,
  styles: [
      `.ant-input {
      //padding: 4px 11px 0 11px;
    }

    .ant-input-affix-wrapper {
      top: -5px;
    }
    `
  ]
})
export class FxCellButtonEditorComponent extends FxAgGridValidationEditorComponent
  implements ICellEditorAngularComp, OnDestroy {
  colId;
  name: string;
  editParams: any;
  modalService;
  multiSelection = false;
  @ViewChild('cellInput') cellInput: ElementRef;
  params: ICellEditorParams;  // 存放cellEditorParams   Added By David Lee 18Feb2019
  valueSetSubscription: Subscription;  // Added by David Lee 25Feb2019
  message: string;

  dwDisabled: boolean = false;  // add by canon

  constructor(private fb: FormBuilder, @Optional() private eventHandler: FxAgGridEventHandlerService) {
    super();
  }

  // gets called once after the editor is created
  agInit(params: ICellEditorParams | any): void {
    this.params = params;  // 把cellEditorParams参数赋给params Added By David Lee 18Feb2019
    this.editType = params.api.gridOptionsWrapper.gridOptions.editType || '';
    const currentValue = this.valueTransfer(params.value);
    this.colId = params.column.colId;
    this.editParams = params;
    this.modalService = params['modalService'];
    this.formControl = new FormControl(currentValue, params.validators);
    this.validateForm = params.form;
    this.dwDisabled = params.dwDisabled;
    if (!params.form) {
      this.validateForm = this.fb.group({});
    }
    // 變更開窗的設定
    // if (this.modalService) {
    //   this.modalService.config.tableMultiSelect = !!params.tableMultiSelect;
    //   this.modalService.config.tableIdField = 'name';
    //   this.multiSelection = this.modalService.config ? this.modalService.config.tableMultiSelect : false;
    // }

    this.name = this.params.node.id + '-' + params.column.colId;

    if ( this.validateForm.contains(this.name)) {
      this.validateForm.setControl(this.name, this.formControl);
    } else {
      this.validateForm.addControl(this.name, this.formControl);
    }


    this.formControl.markAsDirty();

    // 监听赋值 Add David lee 25 Feb 2019
    this.valueSetSubscription = this.eventHandler.valueSet.subscribe(event => {
      if ( (event.colId === this.colId) && (event.gridId === params.context.id) ) {
          this.formControl.setValue(event.value);
          this.message = event.message;
          this.formControl.markAsDirty();
      }
    });


      // 通过订阅消息回传onFocus事件
  this.cellInput.nativeElement.onfocus = (e: any): void => {
    if (this.eventHandler) {
      this.eventHandler.onBeforeField({
        gridId: this.params.context.id,
        value: this.formControl.value,
        rowIndex: this.params.node.rowIndex,
        id: this.params.node.id,
        colId: this.colId,
        controlName: this.name
      });
    }
};

// 通过订阅消息回传onChange事件
this.cellInput.nativeElement.onchange = (event): void => {

if (this.eventHandler) {
this.eventHandler.onChangeField ({
  gridId: this.params.context.id,
  value: this.formControl.value,
  rowIndex: this.params.node.rowIndex,
  id: this.params.node.id,
  colId: this.colId,
  controlName: this.name
  });
}
};

// 通过订阅消息回传onBlur事件
  this.cellInput.nativeElement.onblur = (e: any): void => {
    if (this.eventHandler) {
      this.eventHandler.onAfterField({
        gridId: this.params.context.id,
        value: this.formControl.value,
        rowIndex: this.params.node.rowIndex,
        id: this.params.node.id,
        colId: this.colId,
        controlName: this.name
      });
    }
};

    super.init();
  }

  openModal(): void {
    if (this.eventHandler) {
      this.eventHandler.onBeforeField({
        gridId: this.params.context.id,
        value: this.formControl.value,
        rowIndex: this.params.node.rowIndex,
        id: this.params.node.id,
        colId: this.colId,
        controlName: this.name
      });
      this.eventHandler.onClickOpenButton({
        gridId: this.params.context.id,
        value: this.formControl.value,
        rowIndex: this.params.node.rowIndex,
        id: this.params.node.id,
        colId: this.colId,
        controlName: this.name
      });
    }

    // if (this.modalService) {
    //   if (this.eventHandler) {
    //     this.eventHandler.onBeforeField({
    //       value:  this.formControl.value,
    //       rowIndex: this.params.node.rowIndex,
    //       columnId: this.columnId
    //       });
    //   }
    //   // this.modalService.open(this.formControl.value).subscribe(
    //   this.modalService.searchFx({
    //     modalID: 'qry_aah001',     // (必传) 开窗的编号
    //     postParam: []               // (必传) 查询参数，注意是数组
    //   }).subscribe(
    //     (result) => {
    //       this.setSelectedValue(result[0].aah001);
    //       this.eventHandler.onChangeField({
    //         value:  this.formControl.value,
    //         rowIndex: this.params.node.rowIndex,
    //         columnId: this.columnId
    //         });
    //       this.eventHandler.onAfterField({
    //           value:  this.formControl.value,
    //           rowIndex: this.params.node.rowIndex,
    //           columnId: this.columnId
    //           });
    //     }
    //   );
    // }
  }

  // Gets called once after GUI is attached to DOM.
  // Useful if you want to focus or highlight a component
  // (this is not possible when the element is not attached)
  afterGuiAttached(): void {
    if (this.cellInput && !this.isFullRowEdit()) {
      this.cellInput.nativeElement.focus();
    }
  }

  private valueTransfer(value: any): any {
    let currentValue = value;
    if (this.multiSelection) {
      if (typeof value === 'string') {
        currentValue = value.split(',').map(
          v => v.trim()
        );
      }
    } else {
      if (Array.isArray(value)) {
        currentValue = value.join();
      }
    }
    return currentValue;
  }

  getSelectedValue(): any {
    return this.formControl.value;
  }

  setSelectedValue(value: any): any {
    this.formControl.setValue(value);
  }

  // If doing full row edit, then gets called when tabbing into the cell.
  focusIn(): void {
    this.cellInput.nativeElement.focus();
    // if (this.eventHandler) {
    //  this.eventHandler.onBeforeField({
    //    gridId: this.params.context.id,
    //    value: this.formControl.value,
    //    rowIndex: this.params.node.rowIndex,
    //    id: this.params.node.id,
    //    colId: this.colId,
    //    controlName: this.name
    //  });
    // }
  }

  // If doing full row edit, then gets called when tabbing out of the cell.
  focusOut(): void {
    this.cellInput.nativeElement.blur();
    // if (this.eventHandler) {
    //  this.eventHandler.onAfterField({
    //    gridId: this.params.context.id,
    //    value: this.formControl.value,
    //    rowIndex: this.params.node.rowIndex,
    //    id: this.params.node.id,
    //    colId: this.colId,
    //    controlName: this.name
    //  });
    // }
  }

  // Should return the final value to the grid, the result of the editing
  getValue(): any {
    return this.getSelectedValue();
  }

  // Gets called once before editing starts, to give editor a chance to
  // cancel the editing before it even starts.
  isCancelBeforeStart(): boolean {
    return false;
  }

  // Gets called once when editing is finished (eg if enter is pressed).
  // If you return true, then the result of the edit will be ignored.
  isCancelAfterEnd(): boolean {
    return this.validationMessages.length > 0;
  }

  // Gets called once after initialised.
  // If you return true, the editor will appear in a popup
  isPopup(): boolean {
    return false;
  }

  ngOnDestroy(): void {
    this.validateForm.removeControl(this.name);
    // 当销毁时取消所有订阅
    if (this.valueSetSubscription) {
      this.valueSetSubscription.unsubscribe();
    }
  }

}
